import styled from 'styled-components';

export interface LoadingRinContainerProps {
  color?: string;
  size?: string;
}

export const LoadingRinContainer = styled.div<LoadingRinContainerProps>`
    .lds-ring {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 32px;
    }
    .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${props => props.size || '20px'};
    height: ${props => props.size || '20px'};
    margin: 8px;
    border: 8px solid ${props => props.theme.colors[props.color || 'white']};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color:  ${props => props.theme.colors[props.color || 'white']} transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
    }
    @keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    }
`;